import React, {useState,useEffect} from 'react';
import './CompanyComplaintRegistration.css';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Header from '../header/Header';
import { clearAllPositions, updateDetails } from '../../features/complaintPosition/ComplaintPositionSlice';
import { addComplaintPosition} from '../../features/complaintPositions/ComplaintPositionsSlice';
import MenuCompany from '../menu/MenuCompany';
import red_line from '../../img/red_line.png';
import {ReactComponent as Edit} from '../../img/Edit.svg';
import {ReactComponent as Delete} from '../../img/Delete.svg';
import SelectProductModal from "../selectProductModal/SelectProductModal";
import Modal from "../common/modal/Modal";
import plus from '../../img/plus.png';
import { getQuantityCorrectionsProposals } from '../../features/quantityCorrectionsProposals/QuantityCorrectionsProposalsSlice';
import {setQuantityCorrectionProposal,setShippingMethod,setCourier} from '../../features/complaintPosition/ComplaintPositionSlice';
import { getCouriers } from '../../features/couriers/couriersSlice';
import { getShippingMethods } from '../../features/shippingMethod/shippingMethodSlice';
import { deleteComplaintPosition} from '../../features/complaintPositions/ComplaintPositionsSlice';
import { updateComplaintPosition } from '../../features/complaintPositions/ComplaintPositionsSlice';
import { MobileMenuCompany } from '../mobileMenu/MobileMenuCompany';
import moment from 'moment';
import { setTextForSearching } from '../../features/products/productSlice';
import { ComplaintTypesForms } from '../common/complaintTypesForms/ComplaintTypesForms';
import { IS_INTERNAL_APP } from '../../api/ApiSettings';
import '../pageSize/PageSize.css';
import { clearFiles } from '../../features/files/FileSlice';
import { SaveCancelButtons } from '../common/buttons/saveCancelButtons/SaveCancelButtons';
import { NextAndBackButtons } from '../common/buttons/nextAndBackButtons/NextAndBackButtons';

export const CompanyComplaintRegistration = () => {
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState('');    
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(window.location.pathname);
    const [formSubmitted, setFormSubmitted] = useState(sessionStorage.getItem('formSubmitted') === 'true');
    const [isDelete, setIsDelete] = useState(false);
    const details = useSelector((state)=>state.complaintPosition);
    //COMPLAINT POSITION
    const complaintType = useSelector((state) => state.complaint.complaintType.id);
    const complaintTitle = useSelector((state)=>state.complaint.complaintType.displayName);
    const complaintTypeName = useSelector((state)=>state.complaint.complaintType.name);
    //COMPLAINT POSITIONS
    const positions = useSelector((state) => state.complaintPositions.positions);
    //QUANTITY CORRECTION PROPOSALS
    const couriers = useSelector((state)=>state.couriers.couriers);
    const shipping = useSelector((state)=>state.shipping.shippingMethods);
    const quantityCorrectionsProposal = useSelector(state=>state.quantity.quantityCorrectionsProposals);
    const [positionIdToEdit, setPositionIdToEdit] = useState(null);

    const [formValues, setFormValues] = useState({...details, id:null});
    const [isDataValid, setIsDataValid] = useState(false);
    const [clearText, setClearText] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const complaintPositions = useSelector((state) => state.complaintPositions.positions);
    const matchingPosition = complaintPositions.find((position) => position.id === positionIdToEdit);
    const filesToDisplay = matchingPosition ? matchingPosition.files : [];//COMPLAINT POSITIONS

    useEffect(() => {
        dispatch(getQuantityCorrectionsProposals());
        dispatch(getCouriers());
        dispatch(getShippingMethods());
        }, []);


useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }

  return () => {
    document.body.style.overflow = '';
  };
}, [isOpen]);
    const handleSelectedOption = (option) => {
        setSelectedOption(option);
        setFormErrors((prevErrors)=>({
            ...prevErrors,
            product:null
        }))
       
      };

    const handleDetailsChange = (event) => {
        const { name, value } = event.target;
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
        const updatedFormValues = {
            ...formValues,
            [name]: value,
        };

        if (name === 'quantityCorrectionsProposal') {
            const selectedProposal = quantityCorrectionsProposal.find(item => item.displayName === value);
            updatedFormValues[name] = selectedProposal;
            dispatch(setQuantityCorrectionProposal(selectedProposal));
        }
        if (name === 'shippingMethod') {
            const selectedProposal = shipping.find(item => item.displayName === value);
            updatedFormValues[name] = selectedProposal;
            dispatch(setShippingMethod(selectedProposal));
        }
        if (name === 'courier') {
            const selectedCourier = couriers.find(item => item.displayName === value);
            updatedFormValues[name] = selectedCourier;
            dispatch(setCourier(selectedCourier));
        }
        setFormValues(updatedFormValues);
        dispatch(updateDetails(updatedFormValues));
        validateDate(value);
    };

    const getRequiredFields = (complaintTypeName) => {
        const requiredFieldsMap = {
            'SalesWarranty': [
                "faultDescription", "faultDate", "files", "faultDiscoveryCircumstances", "salesDocumentNumber", "shipmentDescription", "shippingMethod"
            ],
            'UnderWarrantyLaserDeviceCalibration': [
                "faultDescription", "faultDate", "files", "faultDiscoveryCircumstances", "salesDocumentNumber", "shipmentDescription", "shippingMethod"
            ],
            'PayedRepair': [
                "faultDescription", "faultDiscoveryCircumstances", "shippingMethod"
            ],
            'PostWarrantyLaserDeviceCalibration': [
                "faultDescription", "files", "shippingMethod", "shipmentDescription"
            ],
            'Warranty': [
                "faultDescription", "files", "faultDate", "faultDiscoveryCircumstances", "customerRequest", "salesDocumentNumber", "shippingMethod"
            ],
            'DeliveryMismatch': [
                "shippedQuantity", "salesDocumentNumber", "salesDocumentPosition", "quantityCorrectionsProposal"
            ],
            'TransportDamage': [
                "amount", "faultDescription", "files", "salesDocumentNumber", "salesDocumentPosition", "dateOfReceiptOfGoods", "courier"
            ]
        };
        
        return requiredFieldsMap[complaintTypeName] || [];
    };

    const validateRequiredFields = (formValues, requiredFields) => {
        const errors = {};
        requiredFields.forEach(field => {
            if (!formValues[field] && !IS_INTERNAL_APP) {
                errors[field] = "Pole nie może być puste!";
            }
        });
        return errors;
    };

    const validateSpecificFields = (complaintTypeName, formValues, details, errors) => {
        const numberPattern = /^[0-9]+$/;
        
        switch (complaintTypeName) {
            case 'TransportDamage':
                if (!formValues.courier || formValues.courier.length === 0) {
                    errors.courier = "Brak określonego przewoźnika!";
                }
                if (!formValues.amount) {
                    errors.amount = "Pole nie może być puste!";
                } else if (!numberPattern.test(formValues.amount)) {
                    errors.amount = "Wprowadzone dane są niepoprawne!";
                }
                if (!formValues.salesDocumentPosition) {
                    errors.salesDocumentPosition = "Pole nie może być puste!";
                } else if (formValues.salesDocumentPosition < 0) {
                    errors.salesDocumentPosition = "Wprowadzone dane są niepoprawne!";
                }
                break;
            case 'DeliveryMismatch':
                if (details.quantityCorrectionsProposal.value === "NotSpecified") {
                    errors.quantityCorrectionsProposal = "Brak określonego sposobu rozpatrzenia reklamacji!";
                }
                break;
            default:
                break;
        }
        if (!details.product) {
            errors.product = "Proszę wybrać produkt!";
        }
        
        return errors;
    };
    
 
    const validateShippingMethod = (complaintTypeName, formValues, errors) => {
        if (['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration', 'Warranty', 'PostWarrantyLaserDeviceCalibration', 'PayedRepair'].includes(complaintTypeName) &&
            (!IS_INTERNAL_APP && !formValues.shippingMethod || Object.keys(formValues.shippingMethod).length === 0 || formValues.shippingMethod.displayName === 'Nieokreślony' || formValues.shippingMethod.displayName === '')) {
            errors.shippingMethod = "Brak określonego sposobu wysyłki produktu!";
        }
        return errors;
    };

    const validateDate = (date, errorKey) => {
        const currentDate = new Date();
        const enteredDate = new Date(date);
        return enteredDate > currentDate ? { [errorKey]: "Wprowadzona data jest niepoprawna!" } : {};
    };

    const handleSubmit = (e) => {
        e.preventDefault(); 
        
        let errors = {};
        const requiredFields = getRequiredFields(complaintTypeName);
        errors = { ...errors, ...validateRequiredFields(formValues, requiredFields) };
        errors = { ...errors, ...validateSpecificFields(complaintTypeName, formValues, details, errors) };
        errors = { ...errors, ...validateShippingMethod(complaintTypeName, formValues, errors) };

        if (formValues.faultDate) errors = { ...errors, ...validateDate(formValues.faultDate, 'faultDate') };
        if (formValues.dateOfReceiptOfGoods) errors = { ...errors, ...validateDate(formValues.dateOfReceiptOfGoods, 'dateOfReceiptOfGoods') };
        

        const complaintTypesRequiringFiles = ['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration', 'Warranty', 'TransportDamage'];
    
        if (complaintTypesRequiringFiles.includes(complaintTypeName)) {
            const hasNewFiles = details.files && details.files.length > 0;
            const hasExistingFiles = isEditMode && (filesToDisplay.length > 0 || details.files.length > 0);
    
            if (!IS_INTERNAL_APP && !hasNewFiles && !hasExistingFiles) {
                errors.files = "Nie podpięto załączników!";
            }
        }
    

        if (!details.product) errors.product = "Proszę wybrać produkt!";
        
        setFormErrors(errors);

        if (Object.keys(errors).length > 0 && !IS_INTERNAL_APP) {
            setFormSubmitted(false);
        } else {
            const position = positionIdToEdit !== null ? {
                ...formValues, 
                id: positionIdToEdit,
                productDisplayName: formValues.product.name,
                quantityCorrectionsProposalDisplayName: formValues.quantityCorrectionsProposal.displayName,
                files: filesToDisplay
            } : {
                ...details,
                id: positions.length + 1,
                productDisplayName: details.product.name,
                quantityCorrectionsProposalDisplayName: details.quantityCorrectionsProposal.displayName,
            };
            
            dispatch(positionIdToEdit !== null ? updateComplaintPosition(position) : addComplaintPosition(position));
            
            setPositionIdToEdit(null);
            setFormValues({ ...details, id: null });
            setFormSubmitted(true);
            setFormErrors({});
            setIsOpen(false);
        } 
    };

    useEffect(() => {
        const handleWindowResize = () => {
            setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    useEffect(() => {
        function handlePageChange() {
            setCurrentPage(window.location.pathname);
        }
        window.addEventListener("popstate", handlePageChange);
        return () => {
            window.removeEventListener("popstate", handlePageChange);
        };
    }, [currentPage]);
    
   const handleDelete = (positionId) => {
    dispatch(deleteComplaintPosition(positionId));
    setIsDelete(true);
    };

    const handleEdit = (id, selectedProduct) => {
        const position = positions.find((position) => position.id === id);
        if (position) {
            setFormValues({ ...position });
            setPositionIdToEdit(id);
            setSelectedProduct(selectedProduct);
            setIsEditMode(true);
            setIsOpen(true);
        }
    };
    
    const handleNextClick = () => {
        const requiredFields = getRequiredFields(complaintTypeName);
        let errors = {};
        errors = { ...errors, ...validateRequiredFields(formValues, requiredFields) };
        errors = { ...errors, ...validateSpecificFields(complaintTypeName, formValues, details, errors) };

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors); 
            alert("Proszę uzupełnić pola oznaczone gwiazdką!");
            return;
        }
    
        const isComplaintTypeWithFilesRequired = ['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration', 'Warranty', 'TransportDamage'].includes(complaintTypeName);
        
        if (isComplaintTypeWithFilesRequired) {
            const hasNewFiles = formValues.files && formValues.files.length > 0;
            const hasExistingFiles = isEditMode && filesToDisplay && filesToDisplay.length > 0;
    
            if (!IS_INTERNAL_APP && !hasNewFiles && !hasExistingFiles) {
                alert("Formularz musi zawierać pliki przed kontynuowaniem!");
                return;
            }
        }
    
        if (positions.length > 0) {
            setCurrentPage('companyReceiptGoods');
            navigate('/companyReceiptGoods');
        }
    };
    
    
    const handleBackClick = () =>{
        setCurrentPage('companySearch');
        navigate('/companySearch');  
    }

    const handleAddPosition = () => {
        setIsDelete(false);
        const initialFormValues = {
            id: null,
            courier:[],
            faultDescription: '',
            faultDate: moment(),
            faultDiscoveryCircumstances: '',
            salesDocumentNumber: '',
            shipmentDescription: '',
            notes: '',
            shippingMethod: {},
            customerRequest: '',
            shippedQuantity: null,
            salesDocumentPosition: '',
            dateOfReceiptOfGoods: moment(),
            files: [],
            damagePhotoFile: null
        };
        dispatch(clearAllPositions());
        dispatch(clearFiles())
        setFormValues(initialFormValues);
        setClearText(true);
        dispatch(setTextForSearching(''));
        setPositionIdToEdit(null);
        setIsEditMode(false);
        setIsOpen(true);
    };
    const cancelComplaintForm = () =>{
        setIsOpen(!isOpen)
    }

    return (
        <div>
        <Header/>
        {isMobile ? <MobileMenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <MenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}

        <div className="add-complaint-info-container">
            <div className="add-complaint-info-title-container">
                <img style={{marginLeft: "0px"}}  src={red_line} className='red-line'/>
                <h3 className="add-complaint-info-title-text">Zgłoszenie dla {complaintTitle}</h3>
            </div>
            <p className="add-complaint-info-text">
                Firma Pro Sp. z o.o. udziela 24-miesięcznej gwarancji tylko dla produktów z grupy Urządzeń<br/>
                laserowych i optycznych z wyłączeniem akcesoriów laserowych (tyczki, statywy, adaptery, łaty<br/>
                niwelacyjne), 10 letniej gwarancji na libelle dla produktów z grupy: Poziomnice, Łaty, Kątownice.<br/><br/>
                Reklamacje na pozostałe produkty należy składać bezpośrednio u sprzedawcy.
            </p>
            {positions.map((position, index) => {
                                return (
                                    <div key={index} className="added-position-container">
                                    <div className="added-position-product-container">
                                        <p className="added-position-product-name"><b>{position.product.name}</b></p>
                                        <p className="added-position-index-code">Indeks: {position.product.code}</p>
                                    </div>
                
                                        <Edit style={{marginRight:'10px', cursor:'pointer'}} className="edit-btn" onClick={()=>handleEdit(position.id, position.product)} type='button' />
                                        <Delete style={{cursor:'pointer'}} className="delete-btn" onClick={()=>handleDelete(position.id)} type="button"/>
                                   
                                    </div>
                                );
                                })}

                <button className="add-position-btn" onClick={handleAddPosition}><p className="add-position-btn-text"><img src={plus}/> Dodaj pozycję</p></button>

                 </div>
        
                    <Modal
                        open={isOpen}
                        onClose={cancelComplaintForm}
                        footer={
                            <SaveCancelButtons
                            onCancel={cancelComplaintForm}
                            saveButtonType="submit"
                            onSave={handleSubmit}
                            formId="companyComplaintForm"
                            />
                        }
                        >
                        <div className="registration-container">
                            <div className={
                            complaintTypeName === 'PayedRepair' ||
                            complaintTypeName === 'PostWarrantyLaserDeviceCalibration' ||
                            complaintTypeName === 'DeliveryMismatch' ||
                            complaintTypeName === 'TransportDamage'
                                ? "modal-container-other"
                                : "modal-container"
                            }>

                            <div className="modal-title">
                                <img
                                src={red_line}
                                className='red-line'
                                style={{marginLeft:'0px', top:'2%'}}
                                />
                                <p className="modal-title-text">
                                Zgłoszenie dla {complaintTitle}
                                </p>
                            </div>

                            <form onSubmit={handleSubmit} id="companyComplaintForm">
                                <div className="modal-text-field">

                                <div>
                                    <label>Produkt*</label>
                                    <SelectProductModal
                                    setSelectedProduct={handleSelectedOption}
                                    complaintType={complaintType}
                                    selectedRow={selectedProduct}
                                    clearText={clearText}
                                    setClearText={setClearText}
                                    isEditMode={isEditMode}
                                    style={{
                                        border: formErrors.product
                                        ? "1px solid red"
                                        : "1px solid #ccc",
                                        fontFamily: 'Montserrat',
                                        fontWeight: '400',
                                        fontSize: '16px'
                                    }}
                                    />
                                    {formErrors.product && (
                                    <p className="error" style={{ marginTop: '0px' }}>
                                        {formErrors.product}
                                    </p>
                                    )}
                                </div>

                                <ComplaintTypesForms
                                    complaintTypeName={complaintTypeName}
                                    formValues={formValues}
                                    formErrors={formErrors}
                                    handleDetailsChange={handleDetailsChange}
                                    cancelComplaintForm={cancelComplaintForm}
                                    positionIdToEdit={positionIdToEdit}
                                    isDataValid={isDataValid}
                                />

                                </div>
                            </form>

                            </div>
                        </div>
                    </Modal>
                <NextAndBackButtons onBack={handleBackClick} onNext={handleNextClick}/>
           </div>
      )
}
